module.exports = __webpack_public_path__ + "img/albumcover07.18eed855.jpg";